import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { required } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../Components/Forms/renders";
import AutosugformApi from "../../../Components/Forms/autocompleteapi";
import { fetchSwimmingPoolCompanies, fetchInspectionTemplates } from "../Reducers/actions";

const InspectionForm = (props) => {
  const { handleSubmit, pristine, submitting } = props;
  const dispatch = useDispatch();
  const { swimmingPoolCompanies, inspectionTemplates } = useSelector(state => state.zwembadinspecties);

  useEffect(() => {
    dispatch(fetchSwimmingPoolCompanies());
    dispatch(fetchInspectionTemplates());
  }, [dispatch]);

  // Initialize selectpicker after data is loaded
  useEffect(() => {
    if (swimmingPoolCompanies.length > 0 || inspectionTemplates.length > 0) {
      // Initialize/refresh selectpicker
      if (window.$ && window.$.fn.selectpicker) {
        window.$('.selectpicker').selectpicker('refresh');
      }
    }
  }, [swimmingPoolCompanies, inspectionTemplates]);

  const companiesOptions = swimmingPoolCompanies.reduce((acc, company) => {
    acc[company._id] = company.name;
    return acc;
  }, {});

  const templatesOptions = inspectionTemplates.reduce((acc, template) => {
    acc[template._id] = `${template.name} (${template.category})`;
    return acc;
  }, {});

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <Field
                name="title"
                type="input"
                component={renderField}
                label="Titel van de Inspectie"
                placeholder="Geef deze inspectie een titel..."
              />

              <Field
                name="company_id"
                validate={[required()]}
                component={AutosugformApi}
                label="Selecteer Zwembad"
                placeholder="Zoek zwembad op naam, adres of stad..."
                suggestievalue="name"
                suggestieid="_id"
                url="/api/swimming-pools/companies/search"
                minval={2}
              />

              <Field
                name="template_id"
                validate={[required()]}
                component={renderselect}
                options={templatesOptions}
                label="Selecteer Sjabloon"
              />

              <Field
                name="inspection_date"
                type="date"
                validate={[required()]}
                component={renderField}
                label="Inspectie Datum"
              />

              <Field
                name="start_time"
                type="datetime-local"
                component={renderField}
                label="Start Tijd (optioneel)"
              />

              <Field
                name="general_remarks"
                type="input"
                component={renderTextField}
                label="Algemene Opmerkingen"
              />

              <Field
                name="status"
                type="input"
                component={renderselect}
                options={{
                  draft: "Concept",
                  in_progress: "In uitvoering",
                  completed: "Voltooid",
                  approved: "Goedgekeurd",
                  rejected: "Afgekeurd"
                }}
                label="Status"
              />
            </div>
          </div>

          <div className="pull-left submit mt-3">
            <button
              type="submit"
              className="btn btn-success btn-wd"
              disabled={pristine || submitting}
            >
              Opslaan
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

let ReduxInspectionForm = reduxForm({
  form: "inspection_form",
  enableReinitialize: true
})(InspectionForm);

ReduxInspectionForm = connect((state) => {
  const inspection = state.zwembadinspecties.inspection;

  // Transform the inspection data for the form
  if (inspection) {
    return {
      initialValues: {
        ...inspection,
        // For AutosugformApi: keep the full object if populated, otherwise just the ID
        company_id: typeof inspection.company_id === 'object' && inspection.company_id !== null
          ? inspection.company_id
          : inspection.company_id,
        // For renderselect: extract ID from populated object
        template_id: inspection.template_id?._id || inspection.template_id,
        inspector_id: inspection.inspector_id?._id || inspection.inspector_id,
      }
    };
  }

  return {
    initialValues: {
      status: 'draft',
      inspection_date: new Date().toISOString().split('T')[0]
    }
  };
})(ReduxInspectionForm);

export default ReduxInspectionForm;
